import { emulatorScreen, mobileScreen } from "../../../../utils/styleUtils";

const styles = (theme) => ({
  questionContainer: {
    width: "350px",
    border: "5px solid #003E4C",
    padding: "0px 0px 30px 0px",
    margin: "100px 10px 0px 200px",
    backgroundColor: "#fff",
    [emulatorScreen(theme)]: {
      width: "250px",
      // border: "4px solid #003E4C",
      // padding: "10px 10px 20px 10px",
      // margin: "70px 38px 0px 25px",
      border: "5px solid #003E4C",
      padding: "0px 0px 30px 0px",
      margin: "75px 0px 0px 35px",
    },
    [mobileScreen(theme)]: {
      width: "230px",
      border: "4px solid #003E4C",
      marginTop: "35px",
      padding: "0px 0px 5px 0px",
    },
  },

  questionHeader: {
    display: "flex",
    backgroundColor: "#003E4C",
    height: 30,
  },

  headerIcon: {
    height: 22,
    padding: "2px 12px 0 11px",
    [emulatorScreen(theme)]: {
      height: 21,
      padding: "4px 6px 0 6px",
    },
    [mobileScreen(theme)]: {
      height: 21,
      padding: "4px 6px 0 6px",
    },
  },

  headerText: {
    color: "#FFF",
    fontWeight: "600",
    fontSize: 18,
    fontFamily: "'Oswald', sans-serif",
    paddingLeft: "10px",
    [emulatorScreen(theme)]: {
      fontSize: "12.5px",
      paddingTop: "6px",
    },
    [mobileScreen(theme)]: {
      fontSize: "12.5px",
      paddingTop: "6px",
    },
  },

  questionBody: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    height: 260,
    paddingLeft: 30,
    [emulatorScreen(theme)]: {
      paddingLeft: 17,
      height: 176,
    },
    [mobileScreen(theme)]: {
      paddingLeft: 17,
      height: 176,
    },
  },

  breakingNews: {
    padding: "10px 0px 0px 197px",
    height: "57px",
    width: "50%",
    [emulatorScreen(theme)]: {
      height: "55px",
      padding: "10px 0px 0px 50px",
    },
    [mobileScreen(theme)]: {
      height: "20px",
      padding: "4px 0px 0px 38px",
    },
  },

  circleIcon: {
    position: "absolute",
    top: -74,
    right: -58,
    height: "118px",
    [emulatorScreen(theme)]: {
      top: "-56px",
      right: "-37px",
      height: "70px",
    },
    [mobileScreen(theme)]: {
      top: "-50px",
      right: "-25px",
      height: "50px",
    },
  },

  internationalQuestionDescription: {
    fontSize: 17,
    paddingTop: 15,
    lineHeight: 1.2,
    marginRight: 56,
    color: "#003E4C",
    fontFamily: "'Oswald', sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: 13,
      paddingTop: "11px",
      paddingBottom: 5,
      marginRight: 24,
    },
    [mobileScreen(theme)]: {
      lineHeight: 1.1,
      fontSize: "12px",
      paddingTop: "11px",
      paddingBottom: 5,
      marginRight: 24,
    },
  },

  domesticQuestionDescription: {
    fontSize: 21,
    paddingTop: 17,
    lineHeight: 1.2,
    marginRight: 56,
    color: "#003E4C",
    fontFamily: "'Oswald', sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: 13,
      paddingTop: "11px",
      paddingBottom: 5,
      marginRight: 24,
    },
    [mobileScreen(theme)]: {
      fontSize: "12px",
      paddingTop: "11px",
      paddingBottom: 5,
      marginRight: 24,
    },
  },

  answerDescription: {
    marginRight: 56,
    fontFamily: "'Oswald', sans-serif",
    color: "#7c7c7c",
    fontSize: 19,
    lineHeight: 1.2,
    [emulatorScreen(theme)]: {
      fontSize: 14,
    },
    [mobileScreen(theme)]: {
      fontSize: 11,
    },
  },

  questionTextDiv: {
    marginTop: 12,
    [emulatorScreen(theme)]: {
      marginTop: 10,
    },
    [mobileScreen(theme)]: {
      marginTop: 10,
    },
  },

  questionText: {
    color: "#043e4b",
    fontWeight: "400",
    fontSize: 16,
    letterSpacing: 1,
    marginRight: 22,
    fontFamily: "'Oswald', sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: "12.5px",
      paddingTop: 0,
      // lineHeight: 1.2,
    },
    [mobileScreen(theme)]: {
      fontSize: "12px",
      lineHeight: 1.2,
    },
  },

  questionTextMajor: {
    color: "#00b1d9",
    fontWeight: "600",
    fontSize: 19,
    letterSpacing: 1,
    marginRight: 22,
    fontFamily: "'Oswald', sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: "13px",
      paddingTop: 0,
      lineHeight: 1.2,
    },
    [mobileScreen(theme)]: {
      fontSize: "12px",
      paddingTop: 0,
      lineHeight: 1.2,
    },
  },

  subQuestionText: {
    color: "#00b1d9",
    fontWeight: "400",
    paddingTop: "12px",
    fontSize: "27px",
    fontFamily: "'Oswald', sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: "16px",
    },
    [mobileScreen(theme)]: {
      fontSize: "14px",
      paddingTop: "8px",
    },
  },

  questionTitle: {
    color: "#003E4C",
    fontWeight: "500",
    fontSize: "2rem",
    padding: "60px 20px 60px 0",
    fontFamily: "'Oswald',sans-serif",
    marginLeft: "100px",
    [emulatorScreen(theme)]: {
      padding: "30px 20px 30px 0",
      marginLeft: "62px",
      fontSize: "1.3rem",
    },
    [mobileScreen(theme)]: {
      padding: "20px 0px 20px 0",
      marginLeft: "52px",
      fontSize: "1rem",
    },
  },

  container: {
    width: "360px",
    padding: "30px 10px 30px 30px",
    margin: "100px 10px 0px 40px",
    [emulatorScreen(theme)]: {
      // width: "470px",
      // padding: 0,
      marginTop: 0,
    },
    [mobileScreen(theme)]: {
      width: "433px",
      // padding: 0,
      marginTop: 0,
    },
  },

  tutorialContainer: {
    width: "360px",
    padding: "30px 10px 30px 30px",
    margin: "0px 10px 0px 40px",
    [emulatorScreen(theme)]: {
      width: "470px",
    },
    [mobileScreen(theme)]: {
      width: "433px",
    },
  },

  newQuestionTitle: {
    color: "#003E4C",
    fontWeight: "500",
    fontSize: "22px",
    padding: "20px",
    fontFamily: "'Oswald',sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: "1.3rem",
    },
    [mobileScreen(theme)]: {
      fontSize: "1rem",
    },
  },

  questionButton: {
    border: "3px solid #003E4C",
    borderRadius: "10px",
    cursor: "pointer",
    color: "#003E4C",
  },

  buttonIcon: {
    width: "38%",
  },

  buttonText: {
    height: "100%",
    width: "100%",
    padding: "3px 25px",
    fontWeight: "600",
    fontSize: "14px",
  },

  answerContainer: {
    marginRight: 100,
    width: 430,
    marginTop: 130,
    marginLeft: 150,
    [emulatorScreen(theme)]: {
      marginRight: 0,
      marginLeft: 0,
      width: 340,
      margin: "55px 0px 0px 0px",
      padding: "60px 27px 10px 0px ",
    },
    [mobileScreen(theme)]: {
      width: "240px",
      margin: "10px 38px 0px 0px",
      padding: "60px 27px 10px 0px ",
    },
  },

  noQuiteText: {
    color: "#003E4C",
    fontSize: "1rem",
    marginTop: 15,
    fontFamily: "'Rubik', sans-serif",
    fontWeight: 600,
    marginBottom: 15,
    [emulatorScreen(theme)]: {
      fontSize: "0.8rem",
    },
    [mobileScreen(theme)]: {
      fontSize: "0.6rem",
    },
  },

  answerText: {
    color: "#043e4b",
    fontWeight: "400",
    fontSize: 16,
    marginRight: 25,
    fontFamily: "'Rubik', sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: "13px",
    },
    [mobileScreen(theme)]: {
      fontSize: "10px",
      paddingTop: "4px",
    },
  },

  activeQuestionButton: {
    backgroundColor: "#4AB3D7",
    border: "3px solid #4AB3D7",
    color: "#ffffff",
    cursor: "pointer",
    borderRadius: "10px",
  },

  correctIncorrectIcon: {
    width: "200px",
    fontSize: 22,
    marginTop: 25,
    marginBottom: 25,
    [emulatorScreen(theme)]: {
      width: "120px",
      marginTop: 9,
      marginBottom: 5,
    },
    [mobileScreen(theme)]: {
      width: "100px",
      marginTop: 9,
      marginBottom: 5,
    },
  },
});
export default styles;
